import { render, staticRenderFns } from "./UpdateGlobalNotes.vue?vue&type=template&id=72616ab3&scoped=true&"
import script from "./UpdateGlobalNotes.vue?vue&type=script&lang=js&"
export * from "./UpdateGlobalNotes.vue?vue&type=script&lang=js&"
import style0 from "./UpdateGlobalNotes.vue?vue&type=style&index=0&id=72616ab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72616ab3",
  null
  
)

export default component.exports